export { default } from './Leadership';
